import { render, staticRenderFns } from "./VerificationCode.vue?vue&type=template&id=8018d24e&scoped=true&"
import script from "./VerificationCode.vue?vue&type=script&lang=js&"
export * from "./VerificationCode.vue?vue&type=script&lang=js&"
import style0 from "./VerificationCode.vue?vue&type=style&index=0&id=8018d24e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8018d24e",
  null
  
)

export default component.exports